export enum Difficulty {
  easy = "easy",
  medium = "medium",
  hard = "hard",
}

export function isDifficulty(value: any): value is Difficulty {
  return Object.values(Difficulty).includes(value);
}
